<template lang="html">
  <section :class="`main-view ${mainViewExpand&&'expand'}`" :style="globalCssVar">
    <div class="container-scroller">
      <app-header :isMobile="isMobile" :themeConfig="themeConfig" />
      <div class="container-fluid page-body-wrapper">
        <b-sidebar
          v-if="isMobile"
          class="app-sidebar"
          id="sidebar-backdrop"
          backdrop
          shadow
          width="270px"
        >
          <app-sidebar @updateView="updateView" :themeConfig="themeConfig" />
        </b-sidebar>
        <app-sidebar v-else @updateView="updateView" :themeConfig="themeConfig" />
        <div class="main-panel">
          <div class="content-wrapper">
            <router-view :key="$route.fullPath"></router-view>
          </div>
          <app-footer v-if="footerText" :footer-text="footerText" />
        </div>
      </div>
    </div>


   


     <!-- 回到頂端按鈕 -->
     <button
      class="back-to-top"
      v-show="showBackToTop"
      @click="scrollToTop"
      aria-label="Back to top"
    >
      <span class="mdi mdi-chevron-up mdi-36px"></span>
    </button>

    <!-- 移動到最下方的按鈕 -->
    <button
      class="move-to-bottom"
      v-show="showMoveToBottom"
      @click="scrollToBottom"
      aria-label="Move to bottom"
    >
      <span class="mdi mdi-chevron-down mdi-36px"></span>
    </button>

    <script type="application/javascript">{{dashboardScript}}</script>
  </section>
</template>

<script lang="js">
import { mapState } from "vuex";
import AppHeader from '@/components/partials/AppHeader'
import AppSidebar from '@/components/partials/AppSidebar'
import AppFooter from '@/components/partials/AppFooter'
import {
  initDashboardBroadcast,
  destroyDashboardBroadcast,
} from '@/services/dashboardBroadcast'

export default {
  components: {
    AppHeader,
    AppSidebar,
    AppFooter
  },
  data () {
    return {
      viewKey: Date.now(),
      isMobile: false,
      showBackToTop: false, // 新增
      showMoveToBottom: false, // 新增
    }
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
      organizationThemeConfig: state => state.organizationThemeConfig,
      mainViewExpand:state=>state.mainViewExpand,
      currentBranch: (state) => state.currentBranch,
      myOrganizations: (state) => state.myOrganizations,
    }),
    ...mapState("auth", {
      user: (state) => state.user,
    }),
    themeConfig() {
      return this.organizationThemeConfig?.dashboard ??  {
        sidebar_bg_color: '#636363',
        sidebar_menu_color: "#8798ad",
        sidebar_menu_active_bg_color: "#fafbfc",
        sidebar_menu_active_color: "#8798ad",
        og_title: null,
        og_favicon_url: null,
      }
    },
    dashboardScript() {
      if (this.organization.dashboard_script_variable) {
        return this.organization.dashboard_script_variable.value.trim().replace(/^<script>/i, '').replace(/<\/script>$/, '')
      }
      return null
    },
    globalCssVar() {
      return {
        "--sidebar-bg-color": this.themeConfig.sidebar_bg_color,
        "--sidebar_menu_color": this.themeConfig.sidebar_menu_color,
        "--sidebar_menu_active_bg_color": this.themeConfig.sidebar_menu_active_bg_color,
        "--sidebar_menu_active_color": this.themeConfig.sidebar_menu_active_color
      };
    },
    footerText() {
      return this.organizationThemeConfig?.dashboard?.footer_text
    },
    dashboardBroadcastConfig() {
      // myOrganizations 讓權限載入後能重新計算
      void this.myOrganizations

      return {
        staffId: this.user?.id ?? null,
        branchId: this.currentBranch?.id ?? null,
        permissions: {
          MY_NOTIFICATION: this.$permissions.has(this.$permissions.consts.MY_NOTIFICATION),
        },
      }
    },
  },
  watch: {
    dashboardBroadcastConfig: {
      handler(config) {
        initDashboardBroadcast(config)
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
    window.addEventListener('scroll', this.handleScroll) // 新增
    document.body.classList.add('admin-panel')
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('scroll', this.handleScroll) // 新增
    destroyDashboardBroadcast()
  },
  methods: {
    updateView () {
      this.viewKey = Date.now()
    },
    onResize() {
      this.isMobile = window.innerWidth < 768
    },
    handleScroll() { // 新增：監聽滾動顯示/隱藏按鈕
      this.showBackToTop = window.pageYOffset > 400;
      this.showMoveToBottom = (window.innerHeight + window.pageYOffset) < document.body.scrollHeight - 20;
    },
    scrollToTop() { // 新增：平滑回頂端
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    scrollToBottom() { // 新增：平滑移動到最下方
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    },
  }
}
</script>

<style lang="scss">
@import "../../../node_modules/flag-icon-css/css/flag-icon.min.css";
@import "../../../node_modules/font-awesome/css/font-awesome.min.css";
@import "../../../node_modules/simple-line-icons/css/simple-line-icons.css";
@import "../../../node_modules/ti-icons/css/themify-icons.css";
@import "../../../node_modules/ionicons/dist/css/ionicons.min.css";
@import "../../../node_modules/codemirror/lib/codemirror.css";
@import "../../../node_modules/vue-snotify/styles/material.css";
@import "../../../node_modules/typicons.font/src/font/typicons.css";

/* override b-sidebar background color in mobile  */
.b-sidebar-header,
.b-sidebar-body,
.sidebar {
  background: var(--sidebar-bg-color);
}

.preserve-spacing-for-datetime-picker {
  // NOTE: date picker & time picker 的選單會超出畫面下緣，因此目前先以增加 margin 的方式快速修正
  // 若要從根本解決的話可以研究 date picker & time picker 是否有提供參數讓選擇的介面根據螢幕大小自動調整選擇介面的位置
  margin-bottom: 240px;
}


.back-to-top {
  position: fixed;
  right: 24px;
  bottom: 80px;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 10px;
  background: rgba(205, 209, 212, 0.9); // #CDD1D4, opacity 0.9
  color: rgba(60, 64, 67, 0.9);          // #3C4043, opacity 0.9
  display: flex;
  align-items: center;
  justify-content: center;  
  cursor: pointer;
  z-index: 1000;
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.back-to-top:hover {
  transform: translateY(-2px);
}

.move-to-bottom {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 10px;
  background: rgba(205, 209, 212, 0.9); // #CDD1D4, opacity 0.9
  color: rgba(60, 64, 67, 0.9);          // #3C4043, opacity 0.9
  display: flex;
  align-items: center;
  justify-content: center;  
  cursor: pointer;
  z-index: 1000;
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.move-to-bottom:hover {
  transform: translateY(2px);
}
</style>
